module.exports = {
	"version": "0.20.7"
};


//////////////////
// WEBPACK FOOTER
// ./~/web3/lib/version.json
// module id = 573
// module chunks = 0